(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-with-podium.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-with-podium.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const tickets = svs.tickets;
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const ImageMemo = tickets.next.components.ImageMemo;
const TicketWithPodiumShadow = tickets.next.components.TicketWithPodiumShadow;
const PriceLabel = svs.tickets.next.components.nova.PriceLabel;
const PriceLabelCurrency = svs.tickets.next.components.nova.PriceLabelCurrency;
const getImageSource = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return image.src || image.url || image.noscriptUrl || image.originalUrl || '';
};
const getImageAspectRatio = function () {
  let image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const width = Number(image === null || image === void 0 ? void 0 : image.width);
  const height = Number(image === null || image === void 0 ? void 0 : image.height);
  if (Number.isFinite(width) && Number.isFinite(height) && height > 0) {
    return width / height;
  }
  return 1;
};
const usePriceLabelSize = () => {
  const breakpoint = svs.tickets.next.hooks.useBreakpoints();
  if (breakpoint === 'xs') {
    return 'xs';
  }
  return 'sm';
};
const TicketWithPodium = _ref => {
  let ticketType = _ref.ticketType,
    onClick = _ref.onClick,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? "".concat(svs.core.config.data.svsconfig.cdn, "/images/tickets/next-gen/skin.webp") : _ref$image,
    price = _ref.price;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isImageLoaded = _useState2[0],
    setIsImageLoaded = _useState2[1];
  const priceLabelSize = usePriceLabelSize();
  const hasResolvedImageLoadRef = useRef(false);
  const previousImageSourceRef = useRef(null);
  const imageData = typeof image === 'string' ? {
    src: image
  } : image;
  const imageSource = getImageSource(imageData);
  const imageAspectRatio = getImageAspectRatio(imageData);
  const showImagePlaceholder = !isImageLoaded;
  const placeholderClassName = showImagePlaceholder ? 'ticket-with-podium-image-placeholder ticket-with-podium-image-placeholder--visible' : 'ticket-with-podium-image-placeholder';
  const handleImageLoad = useCallback(() => {
    if (hasResolvedImageLoadRef.current) {
      return;
    }
    hasResolvedImageLoadRef.current = true;
    setIsImageLoaded(true);
  }, []);
  const floatingContent = React.createElement(ImageMemo, {
    cssSelectors: isImageLoaded ? 'ticket-with-podium-image' : 'ticket-with-podium-image ticket-with-podium-image--loading',
    fitWrapper: false,
    image: _objectSpread(_objectSpread({}, imageData), {}, {
      altText: (imageData === null || imageData === void 0 ? void 0 : imageData.altText) || ticketType
    }),
    onLoadCallback: handleImageLoad
  });
  useEffect(() => {
    if (previousImageSourceRef.current === null) {
      previousImageSourceRef.current = imageSource;
      return;
    }
    if (previousImageSourceRef.current !== imageSource) {
      previousImageSourceRef.current = imageSource;
      hasResolvedImageLoadRef.current = false;
      setIsImageLoaded(false);
    }
  }, [imageSource]);
  return React.createElement("div", {
    className: "ticket-with-podium ticket-with-podium--interactive",
    "data-ticket-type": ticketType || ''
  }, React.createElement("div", {
    className: "ticket-with-podium__panel ticket-with-podium-panel"
  }, React.createElement("a", {
    "aria-label": ticketType || 'Välj lott',
    className: "qa-ticket-with-podium-hitbox ticket-with-podium__link",
    href: "#",
    onClick: onClick,
    style: {
      aspectRatio: imageAspectRatio
    }
  }, React.createElement("div", {
    "aria-hidden": "true",
    className: placeholderClassName
  }), floatingContent, React.createElement(PriceLabel, {
    className: "u-position-absolute tickets-next-hero-price-label",
    edge: "trailing",
    size: priceLabelSize,
    variant: "primary"
  }, React.createElement(PriceLabelCurrency, {
    price: price
  })))), React.createElement(TicketWithPodiumShadow, {
    aspectRatio: imageAspectRatio,
    centered: true,
    className: "ticket-with-podium__platform",
    opacity: 0.7,
    translateY: "var(--ticket-with-podium-platform-translate-y)"
  }));
};
setGlobal('svs.tickets.next.components.TicketWithPodium', TicketWithPodium);

 })(window);